// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/StarRating/styles.css
// module id = 3723
// module chunks = 31